export const WHATSAPP_EVENTS = {
	QR_CODE: 'qr_code',
	AUTH_FAIL: 'auth_fail',
	AUTHENTICATED: 'authenticated',
	READY: 'whatsapp_ready',
	FAIL: 'fail',
	ERROR: 'whatsapp_error',
	WHATSAPP_LOADING: 'whatsapp_loading',
	NEW_MESSAGE: 'new_message',
	MESSAGE_SENT: 'message_sent',
	MESSAGE_ACK: 'message_ack',
	DISCONNECT: 'whatsapp_disconnected',
	CHATS_LOADED: 'chats_loaded',
	CHAT_LOADED: 'chat_loaded',

	CHAT_SEEN: 'chat_seen',
	CHAT_SEEN_RESPONSE: 'chat_seen_response',
	DOWNLOAD_MEDIA: 'download_media',
	DOWNLOAD_MEDIA_RESPONSE: 'download_media_response',
};
